import util from '../util/util';

function getParams(baseInfo) {
  const {userId, target, userName, role, roomId, institutionId} = baseInfo;
  return {
    appId: institutionId,
    actorId: userId,
    actorName: userName,
    actorType: role,
    roomId,
    streamUrl: util.getStreamId(baseInfo),
    streamService: window.zbztAVSDK_init_sdk_type,
    version: 1,
    target
  };
};

export default {
  sendJoinAck(baseInfo) {
    const data = {
      'api':'joinAck',
      ...getParams(baseInfo)
    };
    //无target代表广播消息，target代表有定向发送消息
    return data;
  },
  sendAddStream(baseInfo) {
    const data = {
      'api': 'addStream',
      'playMode': '2', //播放流的模式，1全屏播放，2在其视频区正常播放3.只播放音频不播放视频
      ...getParams(baseInfo)
    };
    return data;
  },
  sendUpdateStreamDeviceStatus(baseInfo) {
    const {deviceType, deviceStatus} = baseInfo;
    const data ={
      'api':'updateStreamDeviceStatus',
      'streamType': deviceType, // string 流设备对应类型：1：视频 2：音频 3：音视频 4：截屏 5：截屏+视频 6：截屏+音频
      'status': deviceStatus,   // string 流设备状态 1开启 2关闭 3未找到
      ...getParams(baseInfo)
    };
    return data;
  },
  sendRemoveStream(baseInfo) {
    let data = {
      'api':'removeStream',
      ...getParams(baseInfo)
    };
    return data;
  },
  sendJoin(baseInfo) {
    const data = {
      'api':'join',
      ...getParams(baseInfo)
    };
    return data;
  },
  sendLeave(baseInfo) {
    const data = {
      'api':'leave',
      ...getParams(baseInfo)
    };
    return data;
  }
};
